import { type FC, type PropsWithChildren } from 'react';

import { useStyles } from './ButtonSelectOption.styles';

type Props = PropsWithChildren<{
	isSelected: boolean;
	isDisabled?: boolean;
	onClick?: () => void;
	dataCy?: string;
}>;

export const ButtonSelectOption: FC<Props> = ({ isDisabled = false, isSelected, children, onClick, dataCy }) => {
	const { classes, cx } = useStyles();

	return (
		<button
			data-cy={dataCy}
			className={cx(classes.option, {
				[classes.selectedOption]: isSelected,
				[classes.disabledOption]: isDisabled,
			})}
			onClick={onClick}
		>
			{children}
		</button>
	);
};
